<template>
  <div class="tab-infoships">
    <p class="mb-5 text-center">
      The three ropax categories were divided based on the lane metres per
      passenger ratio.
    </p>
    <div class="infoships-box" id="cargo">
      <div class="title">CARGO ROPAX</div>
      <div class="content">
        <img
          class="mb-5 transition scale-effect"
          src="assets/img/cargo_ropax.png"
        />
        <p>
          Focus on the carriage of cargo and a passenger capacity sufficient for
          drivers only. These vessels typically have closed ro-ro spaces and
          large weather decks.
        </p>
      </div>
    </div>
    <hr />
    <div class="infoships-box" id="standard">
      <div class="title">STANDARD ROPAX</div>
      <div class="content">
        <img
          class="mb-5 transition scale-effect"
          src="assets/img/standard_ship.png"
        />
        <p>
          Focus on both the carriage of cargo and passengers. These vessels
          typically have each of the three types of ro-ro spaces: closed ro-ro
          spaces, open ro-ro spaces and weather decks. The size of the weather
          deck is generally medium to large within this category.
        </p>
      </div>
    </div>
    <hr />
    <div class="infoships-box" id="ferry">
      <div class="title">FERRY ROPAX</div>
      <div class="content">
        <img
          class="mb-5 transition scale-effect"
          src="assets/img/ferry_ship.png"
        />
        <p>
          Focus on the carriage of passengers and also cargo similar to a
          Standard RoPax. These ships typically only have closed ro-ro spaces or
          mainly closed ro-ro spaces and a small weather deck.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InfoShips",
  mounted: function() {
    this.$store.commit("setPageClass", "infoships");
    this.$store.commit("setFiresafeNumber", 0);
  }
};
</script>

<style scoped></style>
